<template>
  <div class="addPackageWrapper">
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput label="Цена" placeholder="Введите цену" type="text"
          :value="formData.contractor_work_set_price"
          @change_input="value => onChange('contractor_work_set_price', value)" :allowNegative="false" required style="width: 100%;"/>
      </div>
      <div class="form__item">
        <CustomDate :value="formData.date_begin" @change_date="value => onChange('date_begin', value)" required style="width: 100%;"/>
      </div>
      <div class="form__item">
        <CustomDate :value="formData.date_end" @change_date="value => onChange('date_end', value)" style="width: 100%;"/>
      </div>
      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomDate from "@/components/form/CustomDate";

export default {
  name: "add-constructive-price",
  components: { CustomInput, CustomModalFooter, CustomDate },
  props: ["data"],
  data() {
    return {
      loading: false,
      formData: {
        contractor_work_set_id: this.data?.body?.contractor_work_set_id || "",
        contractor_work_set_price: this.data?.body?.contractor_work_set_price || "",
        date_begin: this.data?.body?.date_begin || "",
        date_end: this.data?.body?.date_end || "",
      },
    };
  },
  async mounted() { },

  methods: {
    async onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      const payload = { 
        ...this.formData,
        contractor_work_set_tariff_id: this.data?.body?.contractor_work_set_tariff_id || null,
      }
      this.loading = true;
      await this.data?.onSubmit(payload);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.addPackageWrapper {
  max-width: 700px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
}

.form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
  margin-top: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;

    :deep(.custom-date) {
      width: 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
